{
  "Almost done. Enter your new password here.": "Almost done. Enter your new password here.",
  "Does not include:": "Does not include:",
  "Error getting user details": "Error getting user details",
  "Error updating password: {{errorMessage}}": "Error updating password: {{errorMessage}}",
  "First name": "First name",
  "Last name": "Last name",
  "New Password": "New Password",
  "Please click the button to begin the password reset process.": "Please click the button to begin the password reset process.",
  "Please re-generate the password reset link and try again": "Please re-generate the password reset link and try again",
  "Reset Password": "Reset Password",
  "Secure Password": "Secure Password",
  "Set new password": "Set new password",
  "Should not include a common phrase or dictionary word": "Should not include a common phrase or dictionary word",
  "Sorry, the link has expired.": "Sorry, the link has expired.",
  "Start password reset process": "Start password reset process",
  "Successfully updated password": "Successfully updated password",
  "Username": "Username",
  "Verifying the link...": "Verifying the link...",
  "{{count}} characters minimum_one": "{{count}} character minimum",
  "{{count}} characters minimum_other": "{{count}} characters minimum"
}
